import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import { itemsSelector } from '../selectors';
import {
  fetchDailyReports,
  fetchMonthlyReports,
  fetchYearlyReports,
  fetchCurrentReports,
} from '../actions/entry';
import Report from '../components/Report';

const mapStateToProps = (state) => {
  const items = itemsSelector(state);

  let dailyReportWk = { ...state.reports.dailyReport };
  let monthlyReportWk = { ...state.reports.monthlyReport };
  let yearlyReportWk = { ...state.reports.yearlyReport };

  let dailyReportEnergy = dailyReportWk.energy;
  let monthlyReportEnergy = monthlyReportWk.energy;
  let yearlyReportEnergy = yearlyReportWk.energy;

  dailyReportEnergy = dailyReportEnergy?.map((en) => {
    const den = en;
    if (den?.device?.logicDevice) {
      items
        .filter((f) => f.modelId === en.device.modelId)
        .forEach((it) => {
          if (it.isIntegral || it.isSum) {
            const denItemValue = [];
            dailyReportEnergy.forEach((dit) => {
              if (dit?.[it.itemName] && den?.device?.deviceIds?.includes(dit.device.id)) {
                den[it.itemName]?.forEach((itValue, index) => {
                  denItemValue[index] = denItemValue[index]
                    ? denItemValue[index] + dit?.[it.itemName][index]
                    : dit?.[it.itemName][index];
                });
              }
            });
            den[it.itemName] = denItemValue;
          } else {
            den[it.itemName] =
              dailyReportEnergy.find((enf) => den?.device?.deviceIds?.includes(enf.device.id))?.[
                it.itemName
              ] || den[it.itemName];
          }

          // const summary = den[it.itemName]
          //   .filter((f) => f !== null && f !== undefined)
          //   .reduce(
          //     (summ, current) => ({
          //       sum: summ.sum + +current,
          //       max: !summ.max ? +current : Math.max(summ.max, +current),
          //       min: !summ.min ? +current : Math.min(summ.min, +current),
          //     }),
          //     { sum: 0, max: 0, min: 0 },
          //   );

          // console.log(`den[${it.itemName}]:`, den[it.itemName]);
          // console.log('summary:'<StaticC, summary);
        });
    }

    if (den?.settings) {
      den.settings = sortBy(den.settings, 'position');
    }

    return {
      ...den,
    };
  });

  dailyReportWk = {
    ...dailyReportWk,
    reportItems: sortBy(dailyReportWk.reportItems, 'position'),
    energy: dailyReportEnergy,
  };

  monthlyReportEnergy = monthlyReportEnergy?.map((en) => {
    const den = en;
    if (den?.device?.logicDevice) {
      items
        .filter((f) => f.modelId === en.device.modelId)
        .forEach((it) => {
          if (it.isIntegral || it.isSum) {
            const denItemValue = [];
            monthlyReportEnergy.forEach((dit) => {
              if (dit?.[it.itemName] && den?.device?.deviceIds?.includes(dit.device.id)) {
                den[it.itemName]?.forEach((itValue, index) => {
                  denItemValue[index] = denItemValue[index]
                    ? denItemValue[index] + dit?.[it.itemName][index]
                    : dit?.[it.itemName][index];
                });
              }
            });
            den[it.itemName] = denItemValue;
          } else {
            den[it.itemName] =
              monthlyReportEnergy.find((enf) => den?.device?.deviceIds?.includes(enf.device.id))?.[
                it.itemName
              ] || den[it.itemName];
          }
        });
    }

    if (den?.settings) {
      den.settings = sortBy(den.settings, 'position');
    }

    return {
      ...den,
    };
  });
  monthlyReportWk = {
    ...monthlyReportWk,
    reportItems: sortBy(monthlyReportWk.reportItems, 'position'),
    energy: monthlyReportEnergy,
  };

  yearlyReportEnergy = yearlyReportEnergy?.map((en) => {
    const den = en;
    if (den?.device?.logicDevice) {
      items
        .filter((f) => f.modelId === en.device.modelId)
        .forEach((it) => {
          if (it.isIntegral || it.isSum) {
            const denItemValue = [];
            yearlyReportEnergy.forEach((dit) => {
              if (dit?.[it.itemName] && den?.device?.deviceIds?.includes(dit.device.id)) {
                den[it.itemName]?.forEach((itValue, index) => {
                  denItemValue[index] = denItemValue[index]
                    ? denItemValue[index] + dit?.[it.itemName][index]
                    : dit?.[it.itemName][index];
                });
              }
            });
            den[it.itemName] = denItemValue;
          } else {
            den[it.itemName] =
              yearlyReportEnergy.find((enf) => den?.device?.deviceIds?.includes(enf.device.id))?.[
                it.itemName
              ] || den[it.itemName];
          }
        });
    }

    if (den?.settings) {
      den.settings = sortBy(den.settings, 'position');
    }

    return {
      ...den,
    };
  });
  yearlyReportWk = {
    ...yearlyReportWk,
    reportItems: sortBy(yearlyReportWk.reportItems, 'position'),
    energy: yearlyReportEnergy,
  };

  return {
    dailyReportWk,
    monthlyReportWk,
    yearlyReportWk,
    // isEditable: isAdmin || isManager,
    isEditable: true, // user can export report (spec change by Mr.Thuc request)
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onChangeDaily: fetchDailyReports,
      onChangeDailyInterval: fetchDailyReports,
      onChangeMonthly: fetchMonthlyReports,
      onChangeYearly: fetchYearlyReports,
      onFetchReports: fetchCurrentReports,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Report);
